import { getAutoshipMaxSavings } from '@libs/common-next';
import { AUTOSHIP_FREE_SHIPPING_THRESHOLD, AUTOSHIP_RECURRING_ORDERS_DISCOUNT } from '@libs/core';

export type GetAutoshipDiscountMessagesParams = {
    isFirstAutoshipEligible: boolean;
    discountDisplay?: string;
};

export function getAutoshipDiscountMessages({
    discountDisplay,
    isFirstAutoshipEligible,
}: GetAutoshipDiscountMessagesParams) {
    // If there is no discount display the SKU is most likely
    // MAP restricted, so the generic message should be returned
    if (!discountDisplay?.trim()) {
        return {
            autoshipDiscountHeader: 'Subscribe with Autoship',
            autoshipDiscountSubtext: `Future orders ship on your schedule & get FREE shipping over ${AUTOSHIP_FREE_SHIPPING_THRESHOLD}.`,
            autoshipDiscountSubtextTwo: undefined,
        };
    }

    const shouldShowRecurringDiscount = !isFirstAutoshipEligible;
    const recurringDiscount = shouldShowRecurringDiscount ? AUTOSHIP_RECURRING_ORDERS_DISCOUNT : null;
    const displayDiscount = recurringDiscount ?? discountDisplay;
    const maxDiscount = getAutoshipMaxSavings();

    const autoshipDiscountHeader = getAutoshipDiscountHeader(displayDiscount);

    const subtextMessage = shouldShowRecurringDiscount
        ? `Save ${AUTOSHIP_RECURRING_ORDERS_DISCOUNT} on all orders & FREE shipping over ${AUTOSHIP_FREE_SHIPPING_THRESHOLD}.`
        : `Save ${displayDiscount} on your first order (up to ${maxDiscount}).`;

    const autoshipDiscountSubtextTwo = shouldShowRecurringDiscount
        ? undefined
        : `Future orders get ${AUTOSHIP_RECURRING_ORDERS_DISCOUNT} off & FREE shipping over ${AUTOSHIP_FREE_SHIPPING_THRESHOLD}.`;

    return {
        autoshipDiscountHeader,
        autoshipDiscountSubtext: sanitizeWhitespace(subtextMessage),
        autoshipDiscountSubtextTwo,
    };
}

function getAutoshipDiscountHeader(discount: string): string {
    const hasDiscount = discount.trim();

    return hasDiscount ? `Autoship & save ${discount}` : 'Autoship & save';
}

function sanitizeWhitespace(text: string): string {
    return text.replace(/ {2,}/g, ' ');
}
